import { useEffect } from "react"

import RegisterLayout from "components/common/registerLayout"
import withRegisterLayout from "hoc/withRegisterLayout"
import ChangePassword from "pages/password/changePassword"
import ResetPassword from "pages/password/resetPassword"
import { useLocation } from "react-router"
import { Routes, Route, Navigate } from "react-router-dom"
import { RoutePath } from "routes/Route.types"
import { rememberIntendedPath } from "utils/postLoginRedirect"

const SignUpWrapped = withRegisterLayout({
  Component: RegisterLayout,
  registerType: "signUp",
})
const LoginWrapped = withRegisterLayout({
  Component: RegisterLayout,
  registerType: "login",
})

const CatchAllRedirect = () => {
  const location = useLocation()

  useEffect(() => {
    rememberIntendedPath(location)
  }, [location])

  return <Navigate replace to={RoutePath.LOGIN} state={{ from: location }} />
}

const UnauthRoutes = () => {
  const location = useLocation()

  return (
    <Routes>
      <Route
        path={RoutePath.HOMEPAGE}
        element={
          <Navigate
            to={`${RoutePath.LOGIN}${location.search}`}
            replace
            state={{
              isStripe:
                location.pathname === RoutePath.HOMEPAGE &&
                location.search.includes("isStripe"),
            }}
          />
        }
      />
      <Route path={RoutePath.SIGNUP} element={<SignUpWrapped />} />
      <Route path={RoutePath.LOGIN} element={<LoginWrapped />} />
      <Route path={RoutePath.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={RoutePath.CHANGE_PASSWORD} element={<ChangePassword />} />
      <Route path={RoutePath.PAGE404} element={<CatchAllRedirect />} />
    </Routes>
  )
}

export default UnauthRoutes
